<template>
  <footer class="footer-default">
      <div class="container">
        <div class="top">
          <div class="esquerdo">
            <div class="logo">
              <router-link to="/floricultura">
                <img :src="logoUrl" alt="Memorial Parque Maceió" />
              </router-link>
            </div>
            <div class="textos">
              <div class="endereco-contato-email">
                <div class="txt">
                  <p>
                    Av. de Contôrno, s/n - Benedito Bentes, Maceió - AL,
                    57084-646
                  </p>
                </div>
                <div class="txt">
                  <p>(82) 3353-4202</p>
                </div>
              </div>
            </div>
          </div>
          <div class="direito">
          </div>
        </div>
        <div class="down">
          <div class="list grid-2">
            <p>Floricultura</p>
            <nav>
              <ul>
                <li>
                  <router-link to="/floricultura?categoria=coroa">Coroas</router-link>
                </li>
                <li>
                  <router-link to="/floricultura?categoria=buque">Buquês</router-link>
                </li>
                <li>
                  <router-link to="/floricultura?categoria=arranjo">Arranjos</router-link>
                </li>
              </ul>
            </nav>
          </div>
          <div class="list grid-3">
            <p>Já Sou Cliente</p>
            <nav>
              <ul>
                <li>
                  <a
                    href="https://jazigo.memorialparquemaceio.com.br/"
                    target="_blank"
                    >Localize seu jazigo</a
                  >
                </li>
                <li>
                  <a
                    href="https://velorios.gpdf.com.br/memorial"
                    target="_blank"
                    >Nota de Falecimento</a
                  >
                </li>
                <li>
                  <a
                    href="https://pagamento.memorialparquemaceio.com.br/#/"
                    target="_blank"
                    >Pagamentos</a
                  >
                </li>
                <li>
                  <a
                    href="https://parquedasrecordacoes.com.br/lista-postagens/aovivo"
                    target="_blank"
                    >Velorio Virtual</a
                  >
                </li>
              </ul>
            </nav>
          </div>
          <div class="list grid-4">
            <p>Contato</p>
            <nav>
              <ul>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=5582991229510"
                    class="telefone"
                    target="_blank"
                    >Setor Financeiro</a
                  >
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=5582991229510"
                    class="telefone"
                    target="_blank"
                    >Setor Comercial</a
                  >
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=5582991229510"
                    target="_blank"
                    >Atendimento ao Cliente</a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="rodape">
          <div class="memorial">
            <p>© {{ anoAtual }} Memorial Parque Maceió. Todos os direitos reservados.</p>
          </div>
          <div class="redes-sociais">
            <p>Siga e Acompanhe:</p>
            <a
              href="https://www.facebook.com/memorialparquemaceio/?locale=pt_BR"
              target="_blank"
              rel="noopener noreferrer"
            ><img :src="iconFacebook" alt="Facebook"
            /></a>
            <a href="https://www.instagram.com/memorialparque/" target="_blank" rel="noopener noreferrer"
              ><img :src="iconInstagram" alt="Instagram"
            /></a>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      logoUrl: require('@/assets/Logo-Memorial-Parque-M.svg'),
      iconFacebook: require('@/assets/icones/Icon-facebook.svg'),
      iconInstagram: require('@/assets/icones/Icon-Instagram.svg')
    }
  },
  computed: {
    anoAtual() {
      return new Date().getFullYear()
    }
  },
}
</script>

<style scoped>

.footer-default {
  --footer-primary: #34894d;
  --footer-primary-hover: #2d7a42;
  --footer-text-muted: #6b7280;
  font-family: "DM Sans", -apple-system, sans-serif;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
}

.footer-default .container {
  width: 100%;
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 40px;

}

.footer-default .container .top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 4rem 0 2rem 0;
}
.footer-default .container .top .esquerdo .logo {
  margin-bottom: 1rem;
}
.footer-default .container .top .esquerdo .textos {
  margin-bottom: 0;
}
.footer-default .container .top .esquerdo .textos .descricao {
  display: none;
  max-width: 80.3rem;
  margin-bottom: 4.2rem;
}
.footer-default .container .top .esquerdo .textos .descricao p {
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--footer-text-muted);
}
.footer-default .container .top .esquerdo .textos .endereco-contato-email {
  display: flex;
  flex-direction: column;
  align-items: justify;
  justify-content: space-between;
}
.footer-default
  .container
  .top
  .esquerdo
  .textos
  .endereco-contato-email
  .txt:nth-child(1) {
  max-width: 26.2rem;
}
.footer-default
  .container
  .top
  .esquerdo
  .textos
  .endereco-contato-email
  .txt
  p {
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--footer-text-muted);
}

.footer-default .container .down {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.footer-default .container .down .list p {
  margin-bottom: 1rem;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.4;
  color: #1f2937;
}
.footer-default .container .down .list nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-default .container .down .list nav ul li {
  margin-bottom: 0.6rem;
}
.footer-default .container .down .list nav ul li a {
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--footer-text-muted);
  text-decoration: none;
  transition: color 0.2s;
}
.footer-default .container .down .list nav ul li a:hover {
  color: #34894d;
}
.footer-default .container .rodape {
  border-top: 0.2rem solid #34894d;
  padding: 1rem 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.footer-default .container .rodape .memorial p {
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--footer-text-muted);
}
.footer-default .container .rodape .redes-sociais {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem 2rem;
}
.footer-default .container .rodape .redes-sociais p {
  margin-right: 0.8rem;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--footer-text-muted);
}
.footer-default .container .rodape .redes-sociais a:not(:last-child) {
  margin-right: 3.2rem;
}
@media (max-width: 1366px) {
  .footer-default .container .top .direito .form form input {
    width: 45rem;
  }
}
@media (max-width: 1280px) {
  .footer-default .container .top {
    margin-bottom: 1rem;
    flex-direction: column;
  }
  .footer-default .container .top .esquerdo {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .footer-default .container .top .esquerdo .textos {
    margin-bottom: 1rem;
  }
  .footer-default .container .top .direito {
    width: 75%;
  }
  .footer-default .container .top .direito .form form {
    width: 100%;
  }
  .footer-default .container .top .direito .form form input {
    width: 100%;
  }
}
@media (max-width: 1100px) {
  .footer-default .container .down {
    justify-content: space-around;
  }
}
@media (max-width: 700px) {
  .footer-default .container .top {
    flex-direction: column;
  }
  .footer-default .container .top .esquerdo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .footer-default .container .top .esquerdo .textos .endereco-contato-email {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  .footer-default .container .top .direito .form form input {
    width: 48rem;
  }
  .footer-default .container .down {
    display: grid;
    align-items: stretch;
    justify-items: center;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    margin-bottom: 3rem;
  }
}
@media (max-width: 600px) {
  .footer-default .container .rodape {
    flex-direction: column;
  }
  .footer-default .container .rodape .memorial {
    margin-bottom: 4rem;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .footer-default .container .top .direito {
    width: 100%;
  }
  .footer-default .container .top .direito .form form {
    width: 100%;
  }
  .footer-default .container .top .direito .form form input {
    width: 100%;
  }
}
/* Links Legais - LGPD */
.footer-default .legal-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  padding: 2rem 0;
  border-top: 0.1rem solid #e5e7eb;
}

.footer-default .legal-links a {
  font-size: 0.75rem;
  color: var(--footer-text-muted);
  text-decoration: none;
  transition: color 0.2s;
}

.footer-default .legal-links a:hover {
  color: #34894d;
}

.footer-default .legal-links span {
  color: #e5e7eb;
}

</style>
